const Ru = {
  translation: {
    error: {
      doNotHaveAccessToViewThisModule: 'У вас нет доступа к просмотру данного модуля',
      dataEnteredIncorrectly: 'Данные введены некорректно',
      pleaseFillInTheHighlightedFields: 'Пожалуйста заполните выделенные поля',
      errorSavingReport: 'Ошибка при сохранении отчета',
    },
    main: {
      SCcontrolPanel: 'Панель управления СЦ',
      exit: 'Выход',
      instruction: 'Инструкция',
    },
    sideBar: {
      roadRepairPlans: 'План ремонта дорог',
      intersections: 'Пересечения',
      addRoadRepairPlan: 'Добавить план ремонта дорог',
      configuringUsers: 'Настройка пользователей',
      settingUpRoles: 'Настройка ролей',
      settingUpDirectories: 'Настройка справочников',
      makeSchedule: 'Составление расписания',
      userActions: 'Действия пользователей',
      updateData: 'Обновление данных',
      videoStreams: 'Видеопоток',
      healthCare: 'Здравоохранение',
      analytics: 'Аналитические индикаторы',
      preschools: 'Образование',
      budget: 'Доходы и расходы (с накоплением и без)',
      budgetEntering: 'Доходы и расходы',
      schools: 'Школы',
    },
    roadRepairPlan: {
      allRoadRepairPlans: 'Все планы ремонта дорог',
      responsible: 'Ответственный',
      categoryOfWork: 'Категория работ',
      plot: 'Участок',
      street: 'Улица',
      contractor: 'Подрядчик',
      hiddenWork: 'Скрытая работа',
      start: 'Начало',
      end: 'Окончание',
      action: 'Действие',
      edit: 'Редактировать',
      delete: 'Удалить',

      search: 'Поиск',
      reset: 'Сбросить',
      exactlyWantToDelete: 'Точно хотите удалить',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      removed: 'Удалено',
      yes: 'Да',
      no: 'Нет',
    },
    intersections: {
      allIntersections: 'Все пересечения',
      act: 'Действие',
      responsible: 'Ответственные',
      categoryOfWork: 'Категория работ',
      street: 'Улица',
      contractor: 'Подрядчик ',
      action: 'Действие',
      delete: 'Удалить',
      edit: 'Редактировать',

      exactlyWantToDelete: 'Вы точно хотите удалить отчет от',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      removed: 'Удалено',
      obligatoryField: 'Обязательное поле',
    },
    addRoadRepairPlan: {
      addingNewRoadRepairPlan: 'Добавление нового плана ремонта дорог',
      crossing: 'Пересечение',
      chooseTheResponsible: 'Выберите ответственного',
      selectCategoryOfWork: 'Выберите категорию работ ',
      replacingTheWaterSupply: 'Замена водопровода ',
      overhaulOfRoads: 'Капитальный ремонт дорог ',
      pipeReconstruction: 'Реконструкция трубы ',
      mediumRoadRepair: 'Средний ремонт дорог ',
      roadMaintenance: 'Текущий ремонт дорог ',
      overlappingTheStreet: 'Перекрытие улицы ',
      objectTypeOnTheMap: 'Тип объекта на карте ',
      coordinates: 'Координаты ',
      label: 'Метка',
      polygon: 'Полигон',
      dateOfThePlannedStartOfWork: 'Дата планируемого начала работ',
      beginningOfWork: 'Начало работ',
      incompleteDateOfThePlannedStartOfWork: 'Не полная дата планируемого начала работ',
      plannedCompletionDate: 'Дата планируемого окончания работ',
      completionOfWork: 'Окончание работ',
      incompleteDateOfThePlannedCompletionOfWork: 'Не полная дата планируемого окончания работ',
      chooseContractor: 'Выберите подрядчика',
      responsibleRepairContacts: 'Контакты ответственного исполнения ремонта',
      selectRepairExecutionStatus: 'Выберите состояние исполнения ремонта',
      inWork: 'В работе',
      performed: 'Выполнено ',
      scheduledRepairs: 'Запланированный ремонт',
      projectCost: 'Стоимость проекта',
      theAmountPlannedFor2021: 'Сумма запланированная на 2021 г.',
      hideThisRoadRepairPlan: 'Скрыть этот план ремонта дорог',
      addTo: 'Добавить',
      yes: 'Да',
      no: 'Нет',
      responsible: 'Ответственный',
      street: 'Улица',
      plot: 'Участок',
      selectCategory: 'Выберите категорию',
      openingOfTheRoadway: 'Вскрытие дорожного полотна',
      warrantyPeriod: 'Гарантийный период',
      length: 'Протяженность',
      whoAcceptedTheWork: 'Кто принял работы',
      comments: 'Комментарии',

      addedBy: 'Добавлено',
      pleaseFillInTheHighlightedFields: 'Пожалуйста заполните выделенные поля',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      pleaseChooseResponsible: 'Пожалуйста выберите ответственного',
      pleaseEnterTheStreet: 'Пожалуйста введите улицу',
      pleaseSelectCategory: 'Пожалуйста выберите категорию',
      selectRoadPlans: 'Выберите планы дорог',
    },
    configuringUsers: {
      allUsers: 'Все пользователи',
      addUser: 'Добавить пользователя',
      fullName: 'ФИО',
      login: 'Логин',
      role: 'Роль',
      action: 'Действие',
      edit: 'Редактировать',
      delete: 'Удалить',
      password: 'Пароль',
      changeUser: 'Изменить пользователя',
      phoneNumber: 'Номер телефона',
      roles: 'Роли',
      addingNewUser: 'Добавление нового пользователя',
      email: 'Электронная почта',
      savedBy: 'Сохранено',
      thisUserAlreadyExistsPleaseEnterAnother: 'Такой пользователь уже существует, введите другой',
      pleaseFillInAllFields: 'Пожалуйста заполните все поля',
      user: 'Пользователь',
      established: 'создан',
      removed: 'Удалено',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      regions: 'Регионы',
      region: 'Регион',
      editUser: 'Редактировать пользователя',
    },
    settingUpRoles: {
      allRoles: 'Все роли',
      add: 'Добавить',
      delete: 'Удалить',
      changeCase: 'Изменить модуль',
      addRole: 'Добавить роль',
      code: 'Код',
      description: 'Описание',
      case: 'Модуль',
      action: 'Действие',
      edit: 'Редактировать',
      changingRoles: 'Изменение ролей',

      savedBy: 'Сохранено',
      thisUserAlreadyExistsPleaseEnterAnother: 'Такой пользователь уже существует, введите другой',
      pleaseFillInAllFields: 'Пожалуйста заполните все поля',
      loadingPleaseWait: 'Загрузка, пожалуйста подождите',
      addedBy: 'Добавлено',
    },
    settingUpDirectories: {
      categoryReference: 'Справочник категории',
      contractorsDirectory: 'Справочник подрядчиков',
      name: 'Название',
      responsibleDirectory: 'Справочник ответственных',
      delete: 'Удалить',

      addedBy: 'Добавлено',
      exactlyWantToDelete: 'Точно хотите удалить',
      yes: 'Да',
      no: 'Нет',
      enterNewCategory: 'Введите новую категорию',
      addTo: 'Добавить',
      enterResponsible: 'Введите ответственного',
      removed: 'Удалено',
      plus: 'Добавить',
    },
    settingSchedule: {
      locality: 'Населенный пункт',
      distance: 'Расстояние',
      speed: 'Скорость',
      parking: 'Стоянка',
      arrival: 'Прибытие',
      departure: 'Отправление',
      movementTime: 'Время движения',
      directDirection: 'Прямое направление',
      reverseDirection: 'Обратное направление',
    },
    userActions: {
      eventView: 'Просмотр',
      eventCreate: 'Создание',
      eventUpdate: 'Редактирование',
      eventDelete: 'Удаление',
      eventOpenCase: 'Открытие модуля',
      serviceName: 'Наименование услуг',
      serviceCode: 'Код услуги',
      organization: 'Организация',
      modelOrganization: 'Модель',
      chapter: 'Раздел',
      category: 'Категория',
      subcategory: 'Подкатегория',
      reportTitle: 'Тип отчета',
      region: 'Район',
      year: 'Год',
      month: 'Месяц',
      login: 'Логин',
      dateTime: 'Дата',
      action: 'Действие',
      object: 'Объект',
      caseName: 'Название модуля',
      startDate: 'Начало',
      endDate: 'Конец',
      reset: 'Сбросить',
      choose: 'Выбрать',
    },
    chartStatus: {
      year: 'Год',
      search: 'Найти',
      reset: 'Сбросить',
      organization: 'Организация',
      modelOrganization: 'Модель',
      reportTitle: 'Наименование отчёта',
    },
    gosServiceList: {
      serviceList: 'Реестр услуг',
      eventList: 'Реестр мероприятий',
      charts: 'Отчеты',
      createChart: 'Создать отчет',
      chartStatus: 'Статус отчетов',
      successSavingReport: 'Отчет успешно сохранен',
    },
    health: {
      pageTitle: 'Здравоохранение',
      create: 'Создать',
      fltPeriod: 'Период:',
      fltIndicator: 'Показатель:',
      allPeriods: 'Все периоды',
      allIndicators: 'Все показатели',
      colInd: 'Показатель',
      colPeriod: 'Период',
      colPlan: 'План',
      colFact: 'Факт',
      shown: 'Показано записей:',
      of: 'из',
      mTitle: 'Внесение показателя здравоохранения',
      fIndicator: 'Показатель',
      fType: 'Тип периода',
      fYear: 'Год',
      fQuarter: 'Квартал',
      fUnit: 'Единица измерения',
      fPlan: 'Плановое значение',
      fFact: 'Фактическое значение',
      fDir: 'Направление оценки',
      fNote: 'Примечание',
      grpPeriod: 'Отчётный период',
      year: 'Год',
      quarter: 'Квартал',
      choose: '— выберите —',
      autoFill: 'заполнится по показателю',
      phNote: 'Пояснение к внесённым значениям (необязательно)',
      optional: 'Необязательное поле.',
      dirLowerBetter: 'ниже плана — лучше',
      dirHigherBetter: 'выше плана — лучше',
      hintIndicator:
        'Из справочника показателей здравоохранения. Определяет наименование и — автоматически — единицу измерения и направление оценки.',
      hintType:
        'Значение справочника: «Год» → period_type=Жыл (квартал не задаётся); «Квартал» → period_type=Квартал с номером квартала.',
      hintUnit:
        'Заполняется автоматически из справочника показателей. Только отображение, на расчёт не влияет.',
      hintDir:
        'Заполняется автоматически из справочника: «ниже плана — лучше» либо «выше плана — лучше». Определяет расчёт статуса в основной части.',
      hintPlan: 'Числовое (10,2), ≥ 0. Допускается 0. Хранится и сравнивается как есть.',
      hintFact: 'Числовое (10,2), ≥ 0. Статус выполнения рассчитывает основная часть, не форма.',
      reqMsg: 'Поле обязательно для заполнения',
      numMsg: 'Число в формате (10,2), не меньше 0',
      dupMsg:
        'Запись по этому показателю за выбранный отчётный период уже существует. Повтор недопустим.',
      saveError: 'Не удалось сохранить показатель. Попробуйте ещё раз.',
      loadError: 'Не удалось загрузить данные',
      retry: 'Повторить',
      cancel: 'Отмена',
      save: 'Сохранить',
      empty: 'Нет записей по заданным фильтрам',
      toastOk: 'Показатель сохранён',
      toastSub: 'Запись добавлена в перечень и в журнал действий пользователей',
      lblYear: 'год',
      lblQuarters: ['I квартал', 'II квартал', 'III квартал', 'IV квартал'],
      q1: 'I квартал',
      q2: 'II квартал',
      q3: 'III квартал',
      q4: 'IV квартал',
    },
    videoStreams: {
      title: 'Видеопоток',
      create: 'Создать',

      colSrc: 'Наименование источника',
      colAddr: 'Адрес видеопотока',
      colLoc: 'Местоположение',
      colFile: 'Видеофайл',
      colPlan: 'Плановый срок',
      colFact: 'Фактический срок',
      emptyTitle: 'Записей нет',
      emptyText:
        'В перечень ещё не внесено ни одного источника видеопотока. Нажмите «Создать», чтобы добавить первый.',
      errLoad: 'Не удалось загрузить перечень источников видеопотока.',
      retry: 'Повторить',
      mTitle: 'Создание источника видеопотока',
      fSource: 'Наименование источника',
      fAddress: 'Адрес видеопотока',
      fLocation: 'Местоположение',
      fFile: 'Видеофайл',
      fPlan: 'Плановый срок выполнения работ',
      fFact: 'Фактический срок выполнения работ',
      phSource: 'Наименование камеры видеонаблюдения',
      phAddress: 'Адрес места установки камеры',
      phLocation: 'Местоположение камеры видеонаблюдения',
      hintLocation: 'Используется как разрез круговой диаграммы в основной части ПО.',
      hintFile:
        'Видеозапись, прикрепляемая к записи. Рекомендуемый формат — MP4 (H.264). Предельный размер уточнить у профильного отдела.',
      optional: 'Необязательное поле.',
      pick: 'Выберите файл',
      reqMsg: 'Поле обязательно для заполнения',
      reqMsgFile: 'Прикрепите видеофайл',
      cancel: 'Отмена',
      save: 'Сохранить',
      errSave: 'Не удалось сохранить источник. Попробуйте ещё раз.',
      errFile413: 'Файл превышает допустимый размер. Выберите файл меньшего объёма.',
      errFile415: 'Неподдерживаемый формат файла. Рекомендуется MP4 (H.264).',
      toastOk: 'Источник видеопотока сохранён',
      toastSub: 'Запись добавлена в перечень и в журнал действий пользователей.',
    },
    dataUpdate: {
      pageTitle: 'Обновление данных',
      filterPrefix: 'фильтр',
      filterResult: 'Результат',
      filterModule: 'Модуль / источник',
      filterPeriod: 'период',
      dateFrom: 'Обновлено с',
      dateTo: 'Обновлено по',
      reset: 'Сбросить фильтры',
      dateHint: 'При активном диапазоне дат модули без обновления (—) в выборку не попадают.',
      all: 'Все',
      success: 'Успешно',
      error: 'Ошибка',
      noData: 'Нет данных',
      colModule: 'Функциональный модуль',
      colSource: 'Информационная система – источник данных',
      colDate: 'Дата и время последнего обновления',
      colCount: 'Количество полученных записей',
      colResult: 'Результат',
      cntTotal: 'Модулей на обновлении',
      cntSuccess: 'Обновлено успешно',
      cntError: 'С ошибкой',
      cntNever: 'Не обновлялись',
      badgeUnification: 'унификация',
      legendSuccess: 'Успешно — последний сеанс завершён успешно',
      legendError: 'Ошибка — последний сеанс с ошибкой (данные сохранены с прошлого успешного)',
      legendNoData: 'Нет данных — обновление ещё не выполнялось',
      legendNote: 'Цвет обозначает итог сеанса загрузки, а не оценку достижения показателей.',
      empty: 'Нет записей по заданным фильтрам',
      loadError: 'Не удалось загрузить данные',
      retry: 'Повторить',
      dash: '—',
    },
    analyticsIndicators: {
      title: 'Аналитические индикаторы',
      create: 'Создать',
      reset: 'Сбросить',
      perPage: 'стр.',
      retry: 'Повторить',

      flSearch: 'Поиск',
      phSearch: 'Индикатор, отрасль, период',
      flIndicator: 'Индикатор',
      flPeriodType: 'Тип периода',
      flFrom: 'Период с',
      flTo: 'по',
      allItems: 'Все',

      col: {
        indicator: 'Индикатор',
        periodType: 'Тип периода',
        period: 'Период',
        value: 'Значение',
        unit: 'Ед. изм.',
        created: 'Внесено',
      },

      emptyTitle: 'Записи не найдены',
      emptyHint: 'Измените условия поиска или сбросьте фильтры',
      totalLabel: 'Всего записей:',

      selectPlaceholder: '— выберите —',
      selectYear: 'Год',
      phValue: 'Например: 125,2989',

      form: {
        title: 'Создание значения индикатора',
        indicator: 'Индикатор',
        periodType: 'Тип периода',
        period: 'Период',
        value: 'Значение индикатора',
        unit: 'Единица измерения',
        comment: 'Подпись периода на дэшборде',
      },

      hint: {
        indicator: 'Отраслевые индикаторы указаны в виде «Наименование · Отрасль».',
        unit: 'Заполняется автоматически из справочника индикаторов.',
        comment:
          'Формируется автоматически по индикатору и выбранному периоду. Сохраняется в поле «Comment» и отображается на дэшборде под значением индикатора.',
        period: 'Выберите тип периода и год.',
        value: 'Числовое значение, до 4 знаков после запятой.',
        half: 'Полугодовое значение вносится как II квартал нарастающим итогом.',
        saved: 'Будет сохранён период',
      },

      pt: { year: 'Год', half: 'Полугодие', quarter: 'Квартал', month: 'Месяц' },
      halfLabel: 'полугодие',
      quarterLabel: 'квартал',

      err: {
        req: 'Поле обязательно для заполнения',
        num: 'Значение должно быть числом',
        prec: 'Допускается не более 4 знаков после запятой',
        neg: 'Значение не может быть отрицательным',
        dup: 'Значение за этот период уже внесено',
        future: 'Период ещё не завершён',
        save: 'Не удалось сохранить запись. Повторите попытку',
        saveTitle: 'Ошибка сохранения',
        load: 'Не удалось загрузить перечень. Повторите попытку',
        forbidden: 'Недостаточно прав для доступа к разделу',
      },

      cancel: 'Отмена',
      save: 'Сохранить',
      close: 'Закрыть',

      view: {
        title: 'Запись значения индикатора',
        created: 'Внесено',
        by: 'Пользователь',
        range: 'Границы периода',
        sector: 'Отрасль',
      },

      toast: {
        ok: 'Значение индикатора сохранено',
        sub: 'Запись добавлена в перечень и в журнал действий пользователей.',
        link: 'Открыть журнал',
      },
    },
    budget: {
      title: 'Доходы и расходы (с накоплением и без)',
      create: 'Ввести данные за период',
      tabIncome: 'Доходы',
      tabExpense: 'Расходы',
      fYear: 'Отчётный год',
      fStatus: 'Состояние',
      stAll: 'Все периоды',
      stOn: 'Введён',
      stOff: 'Не введён',
      colPeriod: 'Отчётный период',
      colRows: 'Строк',
      colPlan: 'План исполнений',
      colExec: 'Исполнение',
      colPct: '% исполнения',
      colState: 'Состояние',
      stateOn: 'Введён',
      stateOff: 'Не введён',
      actView: 'Просмотр',
      actEnter: 'Ввести',
      emptyList: 'Нет периодов, удовлетворяющих условиям отбора',
      loadError: 'Не удалось загрузить данные',
      retry: 'Повторить',

      mTitleIncome: 'Ввод данных за период — Доходы',
      mTitleExpense: 'Ввод данных за период — Расходы',
      vTitleIncome: 'Просмотр данных за период — Доходы',
      vTitleExpense: 'Просмотр данных за период — Расходы',
      fYear2: 'Отчётный год',
      fMonth: 'Отчётный месяц',
      fSection: 'Сторона бюджета',

      selMonth: '— выберите месяц —',
      mNo: '№',
      mCode: 'Код',
      mName: 'Группа бюджетной классификации (1-й уровень)',
      mPlan: 'План исполнений',
      mExec: 'Исполнение',
      mPct: '%',
      mTotal: 'ИТОГО',

      reqMsg: 'Поле обязательно для заполнения',
      dupMsg: 'Данные за этот период уже введены. Повторный ввод не предусмотрен.',
      errEmpty:
        'Не заполнено значений: {{n}}. Заполните все клетки «План исполнений» и «Исполнение».',
      errNum:
        'Неверный формат числа в строках №: {{n}}. Допускаются цифры, знак «−» и один десятичный разделитель (до 4 знаков).',
      errRange:
        'Значение превышает допустимый предел в строках №: {{n}}. Не более 14 цифр до разделителя и 4 после.',
      errNeg: 'Отрицательные значения по расходам не допускаются. Строки №: {{n}}.',
      warnNeg:
        'Отрицательные значения допустимы только по строкам остатков бюджетных средств. Проверьте строки №: {{n}}. Сохранение не блокируется.',
      saveError: 'Не удалось сохранить данные',
      progress: 'Заполнено {{a}} из {{b}} строк',
      cancel: 'Отмена',
      save: 'Сохранить',
      close: 'Закрыть',
      toastOkIncome: 'Данные по доходам за {{p}} сохранены',
      toastOkExpense: 'Данные по расходам за {{p}} сохранены',
      toastSub: 'Период закрыт для повторного ввода.',
    },
    budgetEntering: {
      pageTitle: 'Доходы и расходы — введение данных',

      tRows: 'Строки отчёта',
      tImport: 'Загрузка файла',
      tBalance: 'Контроль баланса',

      rowsTitle: 'Строки отчёта',
      createRow: 'Создать строку',
      fBudget: 'Бюджет',
      fPeriod: 'Период отчёта',
      fSection: 'Раздел',
      fDepth: 'Уровень',
      fSearch: 'Поиск по коду или наименованию',
      searchPh: '01.01.112 …',
      reset: 'Сбросить',
      allSections: 'Все разделы',
      anyLevel: 'Любой',
      lvlSection: '0 — строка-итог',
      lvlN: '{{n}} уровень',
      colSection: 'Раздел',
      colCode: 'Код классификации',
      colName: 'Наименование',
      colUb: 'Уточнено',
      colAdj: 'Скорректировано',
      colPp: 'План периода',
      colEx: 'Исполнение',
      colP1: '% к плану',
      colActions: '',
      noRows: 'По заданным условиям строк не найдено',
      noName: 'наименование в источнике отсутствует',
      edit: 'Редактировать',
      totalRows: 'Всего записей: {{n}}',
      perPage: 'стр.',
      partial: 'неполный',
      onDate: 'на',

      mRowCreate: 'Строка отчёта — создание',
      mRowEdit: 'Строка отчёта — редактирование',
      refFormNote:
        '<b>Справочная строка.</b> Годовой бюджет и план платежей для неё в форме 1-27 не заполняются — соответствующие блоки скрыты. Введите только сумму исполнения.',

      s1Title: 'Раздел отчёта и код бюджетной классификации',
      lSection: 'Раздел отчёта',
      hSection:
        'Определяет сторону баланса. Раздел берётся из структуры отчёта, а не из положения строки.',
      lLevel: 'Уровень вложенности',
      hLevel: 'Считается автоматически как число заполненных кодов.',
      lCodes: 'Коды бюджетной классификации (код 1 → код 6)',
      hCodes:
        'Заполнять слева направо без пропусков. Все шесть пустые — строка-итог раздела. Ведущие нули значимы: «01» и «1» — разные коды.',
      lName: 'Наименование строки',
      lNoName: 'В источнике наименование отсутствует (подпрограмма «000»)',
      hName:
        'Отмечайте флажок только если в выгрузке ИС «Казначейство» ячейка наименования действительно пуста. Такие строки несут годовой бюджет и не должны удаляться.',

      s2Title: 'Годовой бюджет',
      lAb: 'Утверждённый бюджет',
      hAb: 'Колонка 3 отчёта. Тыс. тенге, до 5 знаков.',
      lUb: 'Уточнённый бюджет',
      hUb: 'Колонка 4 отчёта.',
      lAdj: 'Скорректированный бюджет',
      hAdj: 'Колонка 5. Это база для «% к бюджету» в дашборде.',
      s2Note:
        'На строках подпрограммы «000» (без наименования) заполнены только утверждённый и уточнённый бюджет, а скорректированный, план и исполнение равны нулю. На строках реальных подпрограмм — наоборот. Это нормальное распределение по классификации, нули здесь вводятся осознанно.',

      s3Title: 'План на отчётный период и обязательства',
      lPp: 'Сводный план по платежам',
      hPp: 'Колонка 6. План за отчётный период, а не за год.',
      lCp: 'Сводный план по обязательствам',
      hCp: 'Колонка 7.',
      lCa: 'Принятые обязательства',
      hCa: 'Колонка 8.',
      lUa: 'Неоплаченные обязательства',
      hUa: 'Колонка 9.',

      s4Title: 'Исполнение и контроль',
      lEx: 'Исполнение',
      hEx: 'Колонка 10. Может быть отрицательным (возвраты).',
      lP1: '% к плану периода',
      hP1: 'Считается системой из сумм. При плане 0 — «—».',
      lP2: '% к исполняемому бюджету',
      hP2: 'Исполнение / скорректированный бюджет.',
      hРrefPct: 'Для справочных строк проценты не считаются: плана и годового бюджета по ним нет.',
      s4Checks: 'Автоматические проверки строки',
      chkOblig: 'Принятые минус неоплаченные обязательства равны исполнению',
      chkOffPlan: 'План периода нулевой при ненулевом исполнении — допустимо, но проверьте',
      chkAdjZero:
        'Скорректированный бюджет нулевой при ненулевом уточнённом — типично для строк «000»',
      chkNeg: 'Отрицательное исполнение — допустимо (возвраты), проверьте знак',
      chkNone: 'Замечаний по строке нет',

      cancel: 'Отмена',
      save: 'Сохранить',
      refClearAsk:
        'Для справочных строк годовой бюджет и план платежей в отчёте не заполняются. Введённые значения будут очищены. Продолжить?',
      closeAsk: 'Закрыть без сохранения?',

      eReq: 'Поле обязательно для заполнения',
      eNum: 'Только число, до 5 знаков после запятой',
      eGap: 'Коды заполняются слева направо без пропусков',
      eLen10: 'Код не длиннее 10 символов',
      eCodeFmt: 'Код может содержать только цифры и латинские буквы',
      eLen500: 'Наименование не длиннее 500 символов',
      eDup: 'Строка с таким разделом и кодом в этом периоде уже существует',
      eNoParent: 'Родительский узел «{{p}}» в этом разделе и периоде не найден',

      impTitle: 'Загрузка отчёта из файла',
      lIBudget: 'Вид бюджета',
      lIFile: 'Файл отчёта',
      btnImport: 'Загрузить',
      impNoFile: 'Выберите файл отчёта',
      impDone: 'Файл загружен, тождества сошлись',
      impDoneViol: 'Файл загружен, но балансовые тождества не сходятся',
      impStats:
        'Из файла «{{f}}» загружено строк: {{n}}. Отчётная дата: {{d}}. Данные доступны на дашборде.',
      impViolNote:
        'Данные сохранены и видны на дашборде с предупреждением о нарушении целостности. Проверьте исходный файл.',
      impRegion:
        'Файл сформирован по региону «{{fr}}», а выбран бюджет «{{cr}}». Проверьте вид бюджета.',
      impParseTitle:
        'Ошибка разбора файла. Ни одна строка не сохранена, прежние данные периода не тронуты.',
      impLine: 'Строка {{n}}: {{m}}',
      impSaved: 'Период загружен',

      balNote:
        'Экран показывает, сходятся ли балансовые тождества по введённым данным периода. Пока хотя бы одна проверка красная, период считается незавершённым: дашборд Ситуационного центра выведет по нему предупреждение о нарушении целостности. Исправлять нужно введённые строки, а не подгонять итоги.',
      balTitle: 'Контроль балансовых тождеств периода',
      balChecks: 'Проверки',
      kRes: 'Итого ресурсы',
      kUse: 'Итого использование',
      kResid: 'Невязка',
      kDef: 'Дефицит',
      kSur: 'Профицит',
      id1: 'Дефицит равен доходам минус затраты и разделы III–IV',
      id2: 'Финансирование дефицита равно дефициту с обратным знаком',
      id3: 'Чистое бюджетное кредитование равно выдаче минус погашение',
      id4: 'Сальдо по финансовым активам равно приобретению минус поступления',
      id5: 'Использованные остатки равны остатку на начало минус остаток на конец',
      id6: 'Итого ресурсы равны итого использованию',
      id9: 'Финансирование дефицита равно займам за вычетом погашения плюс использованные остатки',
      resid: 'невязка',
      balMissing: 'Проверено на неполных данных: не введены разделы {{s}}',
      balCarry: 'Остаток на начало года совпадает с остатком на конец предыдущего периода',

      toLog: 'Открыть журнал действий',
      toastSaved: 'Строка сохранена. Запись доступна в дашборде Ситуационного центра.',
      toastPeriod: 'Период создан. Теперь в него можно вводить строки.',
      toastSaveErr: 'Не сохранено: есть незаполненные или неверные поля.',
      toastConflict: 'Запись изменена другим пользователем, обновите форму.',
      refresh: 'Обновить',
      toastNet: 'Сервер недоступен, изменения не сохранены.',
      retry: 'Повторить',
      loadError: 'Не удалось загрузить данные',
    },
    schools: {
      title: 'Школы — перечень организаций образования',
      create: 'Создать',

      fltShift: 'Сменность:',
      fltLang: 'Язык обучения:',
      allShifts: 'Все смены',
      allLangs: 'Все языки',

      colSchool: 'Школа',
      colCap: 'Мощность',
      colStudents: 'Учеников',
      colTeachers: 'Учителей',
      colShift: 'Сменность',
      colLang: 'Язык обучения',

      shown: 'Показано записей:',
      of: 'из',
      noRows: 'По выбранным фильтрам записей нет',
      loadError: 'Не удалось загрузить перечень школ',
      retry: 'Повторить',

      mTitle: 'Создание записи о школе',
      fName: 'Наименование школы',
      fAddr: 'Адрес',
      fShift: 'Сменность',
      fLang: 'Язык обучения',
      fCap: 'Проектная мощность, мест',
      fStudents: 'Число учеников',
      fTeachers: 'Число учителей',
      fDeficit: 'Дефицит мест',
      fSurplus: 'Профицит мест',
      grpCap: 'Мощность и контингент',
      grpAuto: 'Расчётные поля',

      langKz: 'Казахский',
      langRu: 'Русский',
      langBoth: 'Казахский и русский',

      phName: 'Наименование организации образования',
      phAddr: 'Индекс, населённый пункт, улица, дом',
      autoFill: 'рассчитается автоматически',
      optional: 'Необязательное поле.',

      hintCap: 'Целое число, не меньше 1.',
      hintStudents: 'Целое число, не меньше 0.',
      hintTeachers: 'Целое число, не меньше 0.',
      hintDeficit: 'Ученики минус мощность, но не меньше 0.',
      hintSurplus: 'Мощность минус ученики, но не меньше 0.',

      reqMsg: 'Поле обязательно для заполнения',
      numMsg: 'Целое число, не меньше 0',
      capMsg: 'Целое число, не меньше 1',
      langMsg: 'Отметьте хотя бы один язык обучения',
      dupMsg: 'Школа с таким наименованием уже есть в перечне. Повтор недопустим.',
      saveError: 'Не удалось сохранить запись. Повторите попытку.',

      cancel: 'Отмена',
      save: 'Сохранить',

      toastOk: 'Запись о школе сохранена',
      toastSub: 'Запись добавлена в перечень и в',
      toastLog: 'журнал действий пользователей',
    },
    preSchool: {
      title: 'Образование — дошкольные организации',
      create: 'Создать',
      fSearch: 'Поиск',
      phSearch: 'Наименование или адрес',
      fLoc: 'Местность',
      allLoc: 'Все населённые пункты',
      fType: 'Вид ДДО',
      allType: 'Все виды',
      fState: 'Заполненность',
      allState: 'Любое состояние',
      reset: 'Сбросить',
      emptyList: 'Записи не найдены',
      found: 'Найдено записей: {n}',
      toastOk: 'Организация «{n}» создана',
      toastSub: 'Запись добавлена в журнал.',

      // ── Колонки таблицы (columns.jsx) ───────────────────────────
      colName: 'Наименование',
      colLoc: 'Местность',
      colType: 'Вид ДДО',
      colLang: 'Язык обучения',
      colForm: 'Форма учреждения',
      colSeats: 'Проектная мощность',
      colKont: 'Факт. наполненность',
      colDev: 'Отклонение',
      colNapr: 'Выдано направлений',
      colZach: 'Зачислено',
      colState: 'Заполненность',
      colActive: 'Статус',
      actOn: 'Активен',
      actOff: 'Не активен',

      // ── Состояния наполненности (occupancy.js) ──────────────────
      stProf: 'Профицит',
      stNorm: 'Норма',
      stDefic: 'Дефицит',
      stND: 'Нет данных',

      // ── Модальная форма (PreschoolFormModal.jsx) ────────────────
      mTitle: 'Создание дошкольной организации',
      footNote: 'Поля со звёздочкой (*) обязательны.',
      cancel: 'Отмена',
      save: 'Сохранить',
      selPlaceholder: '— выберите —',
      optional: 'Необязательное поле.',

      // Секция 1
      secGeneral: 'Сведения об организации',
      fName: 'Наименование организации',
      phName: 'Полное наименование дошкольной организации',
      fAddr: 'Адрес',
      phAddr: 'Адрес дошкольной организации',
      fDistrict: 'Район',
      fCoords: 'Координаты (широта, долгота)',
      phLat: 'широта',
      phLon: 'долгота',
      hintCoords:
        'Необязательно. Формат до 6 знаков после запятой. Используется для отображения на карте основной части.',

      // Секция 2
      secClass: 'Классификация (разрезы дэшборда)',
      fForm: 'Форма учреждения',
      fTypeF: 'Вид ДДО',
      fLang: 'Язык обучения',
      hintLang: '«Смешанный» — обучение ведётся на казахском и русском языках.',
      fTime: 'Продолжительность нахождения',

      // Секция 3
      secCounts: 'Показатели наполненности и очереди',
      fSeats: 'Проектная мощность',
      phSeats: 'мест',
      fKont: 'Фактическая наполненность',
      phKont: 'детей',
      fFree: 'Свободные места',
      fQueue: 'В очереди',
      fNapr: 'Выдано направлений',
      fZach: 'Зачислено',
      calcDev: 'Отклонение (мощность − факт):',
      calcState: 'Состояние наполненности:',
      calcHint: 'Рассчитывается ПО автоматически при сохранении и не вводится вручную.',

      // Секция 4
      secMeta: 'Отчётность и учёт',
      fPeriod: 'Отчётный период',
      fActive: 'Статус активности',
      hintActive: '«Не активен» — организация не учитывается при построении дэшборда.',

      // Валидация / ошибки
      reqMsg: 'Поле обязательно для заполнения',
      numMsg: 'Допускается только целое число (≥ 0)',
      numMsgCoords: 'Допускается только число (до 6 знаков после запятой)',
      alertReq: 'Проверьте обязательные поля.',
      alertServer: 'Ошибка сервера. Попробуйте позже.',
    },
  },
};

export default Ru;
